var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSetting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    rx: 4,
    fill: "#F7F8F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7269_44449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 16.2907V12.7087H21.1328C20.9847 12.1263 20.7578 11.5756 20.4669 11.0661L22.1307 9.40172L19.5977 6.86875L17.9175 8.54897C17.412 8.26864 16.8661 8.05296 16.2907 7.9125V5.5H12.7087V8.0365C12.1903 8.20223 11.699 8.43026 11.2447 8.71235L9.40231 6.86992L6.86934 9.4029L8.81873 11.3523C8.60128 11.7801 8.42791 12.2338 8.30684 12.7093H5.5V16.2913H8.39735C8.53252 16.728 8.71177 17.1446 8.9298 17.5372L6.86934 19.5977L9.40231 22.1307L11.4469 20.0861C11.8442 20.3129 12.2662 20.501 12.7087 20.6426V23.5H16.2907V20.7654C16.7867 20.6438 17.261 20.4663 17.7065 20.24L19.5971 22.1307L22.1301 19.5977L20.3464 17.814C20.6391 17.3421 20.8742 16.8314 21.0417 16.2913H23.4994L23.5 16.2907ZM11.1683 14.339C11.1683 12.3808 12.7616 10.7875 14.7198 10.7875C16.678 10.7875 18.2713 12.3808 18.2713 14.339C18.2713 16.2972 16.678 17.8904 14.7198 17.8904C12.7616 17.8904 11.1683 16.2972 11.1683 14.339Z",
    fill: "#ADB5BD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7269_44449"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(5.5 5.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.f8e4167c.svg";
export { ForwardRef as ReactComponent };